import { FunctionComponent, useState } from 'react';

import { Locales } from 'types/locale';
import { Routes } from 'types/routes';

import { select as selectLocale } from 'utils/locale';
import { withVariables } from 'utils/string';

import Button, {
    ButtonLayouts,
    ButtonSizes,
    ButtonTypes,
} from 'components/layout/Button';
import Form from 'components/layout/forms/Form';
import Input, { InputStyles } from 'components/layout/forms/Input';
import InputRow from 'components/layout/forms/InputRow';

import { Props } from './index';
import StyledComponent from './styles';

const PanelFormUserPhoneLogin: FunctionComponent<Props> = ({ actions, phoneNumber, onSuccess }) => {
    const [readyToLogin, setReadyToLogin] = useState<boolean>(false);
    const [delay, setDelay] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>(null);

    const translations = selectLocale({
        [Locales.En]: require('./locales/en.json'),
        [Locales.Pl]: require('./locales/pl.json'),
    });

    return (
        <StyledComponent className="panel-form-user-phone-login">
            <div
                className="information"
                dangerouslySetInnerHTML={{ __html: translations?.information }}
            />
            <Form
                submitAction={(values) => {
                    if (delay) return;
                    setDelay(true);

                    if (!readyToLogin) {
                        return actions.assignCode({
                            phone: values.phone || phoneNumber,
                        }).then(() => {
                            setDelay(false);
                            setReadyToLogin(true);
                            setErrorMessage(null);
                        }).catch(error => {
                            console.error(error);
                            setDelay(false);
                            setErrorMessage(translations?.error?.phone);
                        });
                    }

                    return actions.loginByPhone({
                        phone: values.phone || phoneNumber,
                        code: values.code,
                    }).then(() => {
                        setDelay(false);
                        setErrorMessage(null);
                        onSuccess();
                    }).catch(error => {
                        console.error(error);
                        setDelay(false);
                        setErrorMessage(translations?.error?.code);
                    });
                }}
                errorMessage={errorMessage}
            >
                {({ formik }) => {
                    return (
                        <>
                            {readyToLogin ? (
                                <>
                                    <Input
                                        name="code"
                                        type="text"
                                        style={InputStyles.Secondary}
                                        label={translations?.inputs?.code?.label}
                                        placeholder={translations?.inputs?.code?.placeholder}
                                        onChange={formik.handleChange}
                                        value={formik.values.code}
                                    />
                                    <Button
                                        className="form-control"
                                        type={ButtonTypes.Submit}
                                        layout={ButtonLayouts.Block}
                                        size={ButtonSizes.Large}
                                        loading={formik.isSubmitting}
                                    >
                                        {translations?.inputs?.buttons?.submit?.label}
                                    </Button>
                                    <div className="form-footer">
                                        <div
                                            className="footer-title"
                                            dangerouslySetInnerHTML={{ __html: withVariables(translations?.footerTitle, { value: Routes.PublicRegulations }) }}
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <InputRow>
                                        <Input
                                            name="phone"
                                            type="text"
                                            style={InputStyles.Primary}
                                            label={translations?.inputs?.phone?.label}
                                            placeholder={translations?.inputs?.phone?.placeholder}
                                            onChange={formik.handleChange}
                                            value={formik.values.phone || phoneNumber}
                                            required={true}
                                        />
                                    </InputRow>
                                    <Button
                                        className="form-control"
                                        type={ButtonTypes.Submit}
                                        layout={ButtonLayouts.Block}
                                        size={ButtonSizes.Large}
                                        loading={formik.isSubmitting}
                                    >
                                        {translations?.inputs?.buttons?.send?.label}
                                    </Button>
                                </>
                            )}
                        </>
                    );
                }}
            </Form>
        </StyledComponent>
    );
};

export default PanelFormUserPhoneLogin;
